import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function getDebtProject(project_uid, onlyactivedebt, type){
  return request({
    url: `/api/debts/project/${project_uid}?onlyactivedebt=${(onlyactivedebt ? "1" : "0")}&type=${type}`,
    method: "get"
  });
}

export function getDebtProjectSummary(project_uid, type){
  return request({
    url: `/api/debts/project/${project_uid}/summary?type=${type}`,
    method: "get"
  });
}


export function getDebtProjectExport(enduser_id, onlyactivedebt, type, filename= ''){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/debts/project/${enduser_id}/excel?access_token=${getToken()}&onlyactivedebt=${(onlyactivedebt ? "1" : "0")}&type=${type}`
  if(filename){
    link.download = filename
  }
  link.click()

}

export function getDebtLedgerSummary(ledger_id){
  return request({
    url: `/api/debts/ledger/${ledger_id}/summary`,
    method: "get"
  });
}

export function getDebtLedgerList(ledger_id){
  return request({
    url: `/api/debts/ledger/${ledger_id}/list`,
    method: "get"
  });
}

export function getDebtLedgerExport(ledger_id, filename=''){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/debts/ledger/${ledger_id}/excel?access_token=${getToken()}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function getDebtCustomerSummary(enduser_id){
  return request({
    url: `/api/debts/customer/${enduser_id}/summary`,
    method: "get"
  });
}

export function getDebtCustomerList(enduser_id){
  return request({
    url: `/api/debts/customer/${enduser_id}/list`,
    method: "get"
  });
}

export function getDebtCustomerExport(enduser_id, filename= ''){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/debts/customer/${enduser_id}/excel?access_token=${getToken()}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function submitGroupCollection(groupName, idempotencyKey){
  return request({
    url: `/api/debts/group-collection/submit`,
    method: "post",
    data: { groupName, idempotencyKey }
  });
}

export function payDebt(uid, bankholderid){
  return request({
    url: `/api/debts/pay/${uid}/${bankholderid}`,
    method: "post",
    data:{}
  });
}

